import { createModalHook } from '../../../../hooks/useModal'

export const usePayMonthlyLimitBreakdownModal = createModalHook()
